import useUpdateSearch from '../../hooks/useUpdateSearch';
import { RecentlySelectedIcon } from 'foundations-assets';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { getRecentSearches } from '../../utils/searchUtils';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecentSearches = () => {
  const recentSearches = getRecentSearches();
  const {
    updateAndRecordSearch
  } = useUpdateSearch();
  const handleSearchClick = (search, event) => {
    trackEvent(event, {
      filterValue: search
    });
    updateAndRecordSearch(search);
  };
  return /*#__PURE__*/_jsx(Grid, {
    children: /*#__PURE__*/_jsx(GridItem, {
      size: {
        xs: 12,
        md: 6
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          as: "h2",
          marginBlockEnd: (recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length) > 0 ? '400' : '200',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'reports.search.recentSearches'
          })
        }), (recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length) > 0 ? recentSearches.map((search, index) => {
          return /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            alignItems: "center",
            marginBlockEnd: "300",
            children: [/*#__PURE__*/_jsx(IconHolder, {
              icon: RecentlySelectedIcon,
              color: "text-core-subtle"
            }), /*#__PURE__*/_jsx(Link, {
              truncate: true,
              truncateStringProps: {
                useFlex: false
              },
              onClick: () => handleSearchClick(search, EVENTS.clickRecentSearch),
              children: search
            })]
          }, index);
        }) : /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'reports.search.noRecentSearches'
          })
        })]
      })
    })
  });
};
export default RecentSearches;